import React, { ReactElement } from 'react';
import { Alert } from 'antd';

export const PendingRenewalBanner = (): ReactElement => (
  <Alert
    type="warning"
    showIcon
    banner
    description="This team's subscription is currently paused. Users cannot sign in, and all accounts are set to expired."
    className="mb-3 mt-4"
  />
);

export default PendingRenewalBanner;
